// src/js/reducers/index.js
import * as types from "../constants/action-types";
import Sorter from '../utils/sorter';

export default function projectReducer(state = [], action) {
    
    switch (action.type) {
       
        case types.LOGOUT:
            return []
        case types.CREATE_PROJECT_SUCCESS:
            var result = [...state, Object.assign({}, action.project)];
            return Sorter.sort(result, 'name');
        case types.UPDATE_PROJECT_SUCCESS:
            console.log('update1')
            var result = [...state.filter(project => project.projectId !== action.project.projectId), Object.assign({}, action.project)];
            return Sorter.sort(result, 'name');
        case types.GET_PROJECT_SUCCESS:
            console.log('update2',action.project)
            var result = [...state.filter(project => project.projectId !== action.project[0].projectId), Object.assign({}, action.project[0])];
            return Sorter.sort(state, 'name');
        case types.LOAD_PROJECT_SUCCESS:
            return Sorter.sort(action.items, 'name');
        case types.REMOVE_PROJECT_SUCCESS:
            var result = state.filter(project => project.projectId !== action.item);
            return Sorter.sort(result,'name');
        
        default:
            return state;
    };
};


